export class SearchPromoteDate {
    endDate?: string;
    startDate?: string;
  
    SearchPromoteDate(): void {
      this.endDate = "";
      this.startDate = "";
    }
  }